import InvestorCategoryEnum from '@constants/enums/investor/category';
import UserStatusEnum from '@constants/enums/user/status';
import ViewingRestrictionStatusEnum from '@constants/enums/viewingRestrictionStatus';

import i18n from '@plugins/i18n';

import { Collection, Investor } from '@/models';

export class InvestorCollection extends Collection {
    static type = 'InvestorCollection';
    static endpoint = Investor.api.index;
    static model = Investor;

    get headers() {
        const auth = this.Auth();

        const isFundManagerOrProvider = auth.is_fund_manager || auth.is_provider;

        return [
            this.createHeader('title', i18n.t('title'), {
                width: '7rem',
                sortable: true,
                filterable: {
                    operators: this.getOperators(['contains', 'eq', 'is_empty'])
                }
            }),
            this.createHeader('name', i18n.t('name'), {
                width: '18rem',
                minWidth: '18rem',
                filterable: true,
                sortable: true,
                sticky: true
            }),
            this.createHeader('gi_ref', i18n.t('client_reference'), {
                filterable: true,
                width: '11rem'
            }),
            this.createHeader('email', i18n.t('email'), {
                width: '18rem',
                minWidth: '18rem',
                filterable: true
            }),
            this.createHeader('status', i18n.t('status'), {
                filterable: true,
                width: '10rem',
                format: 'enum',
                enum: UserStatusEnum,
                enumA11yKey: 'enums.user_status',
                enumTypes: {
                    [UserStatusEnum.ACTIVE]: 'success',
                    [UserStatusEnum.INACTIVE]: 'grey',
                    [UserStatusEnum.SUSPENDED]: 'error',
                    [UserStatusEnum.UNVERIFIED]: 'warning'
                }
            }),
            this.createHeader('portfolio_restriction_status', i18n.t('restriction_status'), {
                active: !isFundManagerOrProvider,
                filterable: true,
                width: '11rem',
                format: 'enum',
                enum: ViewingRestrictionStatusEnum,
                enumA11yKey: 'enums.viewing_restriction_status',
                enumTypes: {
                    [ViewingRestrictionStatusEnum.NONE]: 'success',
                    [ViewingRestrictionStatusEnum.WARNING]: 'warning',
                    [ViewingRestrictionStatusEnum.RESTRICTED]: 'error'
                },
                formatOptions: {
                    tooltip: v => i18n.t(`enums.viewing_restriction_description.${v}`)
                }
            }),
            this.createHeader('category', i18n.t('investor_type'), {
                filterable: true,
                width: '10rem',
                format: 'enum',
                enum: InvestorCategoryEnum,
                enumA11yKey: 'enums.investor_category'
            })
        ];
    }
}

export default InvestorCollection;
